import { API } from '@Providers';

export default async function (cancelCart?: boolean, cartId?: string) {
  const endpoint = cancelCart
    ? `/api/shelter/cart/cancel-cart-session/${cartId}`
    : '/api/shelter/cart/flush-cart-session';

  return await API({ endpoint });
}
